// extracted by mini-css-extract-plugin
export default {"form":"VoucherForm_form__zXTMd","submitButton":"VoucherForm_submitButton__BcA2c"};